import { writable } from "svelte/store";

const stored_section = localStorage.getItem("section");
export const section = writable(stored_section);

section.subscribe(value => {
    console.log(value)
    localStorage.setItem("section", value ? value : 'dashboard');
});